import { Injectable } from "@angular/core";
import { AngularFireAuth } from "angularfire2/auth";
import * as firebase from "firebase";
import "rxjs/add/operator/filter";
import "rxjs/add/operator/first";
import { Facebook } from "@ionic-native/facebook";
import { Platform, AlertController, ToastController } from "ionic-angular";
import { GooglePlus } from "@ionic-native/google-plus";
import { TwitterConnect } from "@ionic-native/twitter-connect";
import { Device } from "@ionic-native/device";

import { FirestoreService } from './FirestoreService';

@Injectable()
export class AuthService {
  public authState: AngularFireAuth;
  uid: any;

  constructor(
    private alertCtrl: AlertController,
    public afAuth: AngularFireAuth,
    private platform: Platform,
    private fb: Facebook,
    private device: Device,
    private firestoreService: FirestoreService,
    private googlePlus: GooglePlus,
    private toastCtrl: ToastController,
    private twitter: TwitterConnect
  ) {
    this.afAuth.authState.subscribe((user: firebase.User) => {
      if (user) {
        this.uid = user.uid;
      } else {
        this.uid = null;
      }
    });
  }

  signInWithFacebookPlugin() {
    if (this.platform.is("cordova")) {
      return this.fb
        .login(["email"])
        .then(res => {
          const facebookCredential = firebase.auth.FacebookAuthProvider.credential(
            res.authResponse.accessToken
          );

          firebase
            .auth()
            .signInWithCredential(facebookCredential)
            .then(
              res => {
                console.log('Success :>> ');
                console.log(res);
              },
              err => {
                console.error("Error: ", err);
                console.log(err);
                throw err;
              }
            );
        })
        .catch(error => {
          throw error;
        });
    } else {
      return this.signInWithFacebookWeb();
    }
  }

  signInWithFacebookWeb() {
    return this.afAuth.auth
      .signInWithPopup(new firebase.auth.FacebookAuthProvider())
      .then(
        (res:any) => {
          console.log("Success: ", res);
          console.log("email: ", res.additionalUserInfo.profile.email);
          console.log("uid: ", res.user.uid);
          console.log("access_token: ", res.credential.accessToken);

          const credential = firebase.auth.FacebookAuthProvider.credential(
            res.credential.accessToken
          );

          firebase
              .auth()
              .signInWithCredential(credential).then(res => {
                var user = <firebase.User>res.user;
        
        
              })
              .catch(error => {
                console.log('failed auth :>> ', error);
                console.log(error);
              });

         

          localStorage.setItem('loggedInUserEmail', res.additionalUserInfo.profile.email);
          localStorage.setItem('loggedInUserUID', res.user.uid);
          this.handleAccountLogins(res.user.uid);
          
        },
        err => {
          console.error("Error: ", err);
          throw err;
        }
      );
  }

  signInWithGooglePlugin() {
    if (this.platform.is("cordova")) {
      return this.googlePlus
        .login({
          webClientId:
            "395983984847-84m1jgom088b1d8jdn36v6rspaov5nhp.apps.googleusercontent.com",
          offline: true
        })
        .then(
          res => {
            const googleCredential = firebase.auth.GoogleAuthProvider.credential(
              res.idToken
            );

            firebase
              .auth()
              .signInWithCredential(googleCredential)
              .then(response => {
                console.log("Firebase success: " + JSON.stringify(response));
              });
          },
          err => {
            console.error("Error: ", err);
            throw err;
          }
        );
    } else {
      return this.signInWithGoogleWeb();
    }
  }

  signInWithGoogleWeb() {
    return this.afAuth.auth
      .signInWithPopup(new firebase.auth.GoogleAuthProvider())
      .then(
        res => {},
        err => {
          console.error("Error: ", err);
          throw err;
        }
      );
  }

  signInWithTwitterPlugin() {
    if (this.platform.is("cordova")) {
      return this.twitter.login().then(
        function(result) {
          console.log("Successful login!");
          console.log(result);
        },
        function(error) {
          console.error("Error logging in");
          console.error(error);
          throw error;
        }
      );
    } else {
      return this.signInWithTwitterWeb();
    }
  }

  signInWithTwitterWeb() {
    return this.afAuth.auth
      .signInWithPopup(new firebase.auth.TwitterAuthProvider())
      .then(
        res => {},
        err => {
          console.error("Error: ", err);
          throw err;
        }
      );
  }

  signInWithGithub() {
    return this.afAuth.auth
      .signInWithPopup(new firebase.auth.GithubAuthProvider())
      .then(res => {});
  }

  registerUser(email, password, password2) {
    return this.afAuth.auth
      .createUserWithEmailAndPassword(email, password)
      .then(res => {
        //alert(JSON.stringify(res))
        let user: any = res.user;

        //localStorage.setItem('loggedInUserUID', user.uid)
        localStorage.setItem('regUserUID', user.uid)
        this.firestoreService.addUser(user.uid, user.email);

        user.sendEmailVerification().then(
          (result: any) => {
            let toast = this.toastCtrl.create({
              message: 'Verification email sent to ' + user.email + '.',
              duration: 3000,
              position: 'bottom'
            });

            toast.present();
          },
          (error: any) => {
            let toast = this.toastCtrl.create({
              message: 'Failed to send verification email.',
              duration: 3000,
              position: 'bottom'
            });

            toast.present();
          }
        );

      })
      .catch(error => {
        throw error;
      });
  }

  registerOrangeUser(email, password) {
    return this.afAuth.auth
      .createUserWithEmailAndPassword(email, password)
      .then(res => {
        //alert(JSON.stringify(res))
        let user: any = res.user;

        //localStorage.setItem('loggedInUserUID', user.uid)
        localStorage.setItem('regUserUID', user.uid)
        this.firestoreService.addUser(user.uid, user.email);

        user.sendEmailVerification().then(
          (result: any) => {
            let toast = this.toastCtrl.create({
              message: 'Verification email sent to ' + user.email + '.',
              duration: 3000,
              position: 'bottom'
            });

            toast.present();
          },
          (error: any) => {
            let toast = this.toastCtrl.create({
              message: 'Failed to send verification email.',
              duration: 3000,
              position: 'bottom'
            });

            toast.present();
          }
        );

      })
      .catch(error => {
        throw error;
      });
  }


  handleAccountLogins(uid) {

    localStorage.setItem('loggedInUserUID', uid);
    let db = firebase.firestore();
    var user = db.collection('users').doc(uid);
    let status: Number;
    //get login count
    user.get().then((res) => {

      let user_info = res.data();

      console.log(user_info)

      if(user_info.loginCount !== undefined) {

        if(user_info.loginCount < 2) {
          let newCount = user_info.loginCount + 1;

          let uuid = this.device.uuid;
          let found: boolean = false;

          //Check if device exists

          this.firestoreService.getMyDevices(uid).then((success: any) => {

            let myDevices = success.myDevices;

            for(let x = 0; x < myDevices.length; x++) {
              if(myDevices[x].uuid == uuid) {
                found = true;
              }
            }

            if(!found) {
              this.firestoreService.addDevice(uid, uuid)
            }

          }).catch(err => {

            //Couldnt fetch data

          });



          /*****************************************************************/


          user.set({
              loginCount: newCount
          }, { merge: true });

          status= 0;

          console.log(status);
        } else {

          //Check if device is known
          let device_uuid = this.device.uuid;
          this.firestoreService.getMyDevices(uid).then((success: any) => {

            let myDevices = success.myDevices;
            let found: boolean = false;

            for(let x = 0; x < myDevices.length; x++) {
              if(myDevices[x].uuid == device_uuid) {
                found = true
              }
            }

            if(found) {
              let newCount = user_info.loginCount;

              user.set({
                  loginCount: newCount
              }, { merge: true });

              status= 0;

              console.log(status);

            } else {
              console.log('You may not log in. Maximum logins with account reached.');

              status = 1;

              this.signOutForce();

              let alert = this.alertCtrl.create({
                title: 'Error',
                subTitle: 'You may not log in. Maximum logins with account reached.',
                buttons: ['Dismiss']
              });

              alert.present();

              console.log(status);
            }

          }).catch(err => {

            //Couldnt fetch data

          });


        }

      } else {
        status = 2;

        console.log(status);
        user.set({
            loginCount: 1
        }, { merge: true });

        let uuid = this.device.uuid;
        this.firestoreService.addDevice(uid, uuid)


      }

    });

  }


  handleAccountLoginsOnLogout() {

    let uid = localStorage.getItem('loggedInUserUID')
    let db = firebase.firestore();
    var user = db.collection('users').doc(uid);

    //get login count
    user.get().then((res) => {

      let user_info = res.data();

      if(user_info.loginCount !== undefined) {

        if(user_info.loginCount > 0) {
          let newCount = user_info.loginCount - 1;
          user.set({
              loginCount: newCount
          }, { merge: true });
        }

      } else {
        user.set({
            loginCount: 0
        }, { merge: true });

      }

      localStorage.removeItem('loggedInUserUID');
      localStorage.removeItem('deviceUuid');
      localStorage.clear();


    });

    /*
    user.set({
        loginCount: 1
    }, { merge: true });
    */
  }



  signIn(email, password) {
    return this.afAuth.auth
      .signInWithEmailAndPassword(email, password)
      .then(res => {
        var user = <firebase.User>res.user;


        if(user.emailVerified === true) {
          localStorage.setItem('loggedInUserUID', user.uid);
          this.handleAccountLogins(user.uid);

          //Check subscription
          this.firestoreService.checkIfSubscribed(user.uid).catch((res) => {


            if(res.isSubscribed) {
              console.log(JSON.stringify(res));

            } else {
              let error = 'subscription';
              throw error;
            }
          })
        } else {
          let error = true;
          throw error;
        }




        /*
        if (!AuthService.isSkip(email) && !user.emailVerified) {
          let alert = this.alertCtrl.create({
            title: 'Log In Warning',
            subTitle: "Please verify you email address before attempting to log in.",
            buttons: ['Dismiss']
          });

          alert.present();
          return;
        }
        */

      })
      .catch(error => {
        throw error;
      });
  }

  signOutForce(): void {
    firebase.auth().signOut();
  }


  signOut(): void {
    let uid = localStorage.getItem('loggedInUserUID');
    let uuid = localStorage.getItem('deviceUuid');
    this.firestoreService.removeDeviceWithUUID(uid, uuid)
    localStorage.removeItem('loggedInUserUID');
    localStorage.removeItem('deviceUuid');
    firebase.auth().signOut();
    this.handleAccountLoginsOnLogout();
  }

  forgotPassword(email) {
    return firebase
      .app()
      .auth()
      .sendPasswordResetEmail(email)
      .then(s => {
        let alert = this.alertCtrl.create({
          title: "Password Reset",
          subTitle: "Check your inbox to reset your password",
          buttons: ["Dismiss"]
        });
        alert.present();
      })
      .catch(error => {
        throw error;
      });
  }

  //Facebook logins
  login(): void {
    if (this.platform.is("capacitor")) {
      this.nativeFacebookAuth();
    } else {
      this.browserFacebookAuth();
    }
  }

  async logout(): Promise<void> {
    if (this.platform.is("capacitor")) {
      try {
        await this.fb.logout(); // Unauth with Facebook
        await firebase.auth().signOut(); // Unauth with Firebase
      } catch (err) {
        console.log(err);
      }
    } else {
      try {
        await firebase.auth().signOut();
      } catch (err) {
        console.log(err);
      }
    }
  }

  async nativeFacebookAuth(): Promise<void> {
    try {
      const response = await this.fb.login(["public_profile", "email"]);

      console.log(response);

      if (response.authResponse) {
        // User is signed-in Facebook.
        const unsubscribe = firebase.auth().onAuthStateChanged(firebaseUser => {
          unsubscribe();
          // Check if we are already signed-in Firebase with the correct user.
          if (!this.isUserEqual(response.authResponse, firebaseUser)) {
            // Build Firebase credential with the Facebook auth token.
            const credential = firebase.auth.FacebookAuthProvider.credential(
              response.authResponse.accessToken
            );
            // Sign in with the credential from the Facebook user.
            firebase
              .auth()
              .signInWithCredential(credential)
              .catch(error => {
                console.log(error);
              });
          } else {
            // User is already signed-in Firebase with the correct user.
            console.log("already signed in");
          }
        });
      } else {
        // User is signed-out of Facebook.
        firebase.auth().signOut();
      }
    } catch (err) {
      console.log(err);
    }
  }

  async browserFacebookAuth(): Promise<void> {
    const provider = new firebase.auth.FacebookAuthProvider();

    try {
      const result = await firebase.auth().signInWithPopup(provider);
      console.log(result);
    } catch (err) {
      console.log(err);
    }

    
  }

  isUserEqual(facebookAuthResponse, firebaseUser): boolean {
    if (firebaseUser) {
      const providerData = firebaseUser.providerData;

      providerData.forEach(data => {
        if (
          data.providerId === firebase.auth.FacebookAuthProvider.PROVIDER_ID &&
          data.uid === facebookAuthResponse.userID
        ) {
          // We don't need to re-auth the Firebase connection.
          return true;
        }
      });
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/services/AuthService.ts